import React from "react";
import MSelectionBar from "./Components/SelectionBar";

export default function CompareTab() {
  return <MSelectionBar />;
}
